<!-- todo 用于显示商品实际数量/库存数量/可输入数量 （进仓管理-进仓明细-货物明细-包装查看）-->
<template>
  <div>
    <span>{{ actual }}/</span><span style="color:red;">{{ inventory }}</span>/<span style="color:red;">{{ valueNum }}</span>
  </div>
</template>

<script>

export default {
  name: 'ColumnNumberDisplayAndInput',
  components: {
  },
  props: {
    custom: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valueNum: 0,
      inventory: 0,
      actual: 0
    }
  },
  created() {
    const data = this.params.data
    const customField = this.params.colDef.custom
    this.inventory = data[customField['inventory']]
    this.actual = data[customField['actual']]
    if (!data[this.params.colDef.field]) {
      this.valueNum = this.inventory
    } else {
      this.valueNum = data[this.params.colDef.field]
      if (this.valueNum > this.inventory || this.valueNum < 0) {
        this.valueNum = this.inventory
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  #app .cargo-number-input >>> input{
    text-align:right;
  }
</style>
